export const convertNumberToPercentage = (number: number | undefined | null) => {
  if (number) {
    return `${number.toFixed(2)}%`;
  } else {
    return `-`;
  }
};
